import mutations from './mutations'
import { loadItemBuilder } from '../crudFactory'

const apiEndpoint = 'articleStock'

export default {
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    loadItem: loadItemBuilder({ apiEndpoint })
  },

  mutations: {
    ...mutations
  }
}
